<template>
  <page-view title="标签管理">
    <template slot="action">
      <a-button @click="tagAdd" icon="tag" type="primary">新建标签</a-button>
    </template>
    <a-card class="mb-3">
      <a-form-model class="exi_form v2"
                    ref="form" :label-col="{ flex: '0 0 auto' }" :wrapper-col="{ span: 24 }">
        <a-form-item label='标签名称' style="width: 600px">
          <a-input v-model="tag.tagName" placeholder="输入标签名称关键字可查询"/>
        </a-form-item>
        <a-button type="primary" @click="onSearch">查询</a-button>
        <a-button @click="reset">重置</a-button>
      </a-form-model>
    </a-card>
    <a-card>
      <s-table
          ref="table"
          :columns="columns"
          :data="loadData"
          :rowKey="record => record.id"
          :pagination="{ showTotal: (total) => `共 ${total} 条` }"
      >
        <template slot="tagName" slot-scope="record">
          <a-tag title="点击查看标签详情..." :color="record.tagColor" @click="doDetail(record.id)">
            {{ record.tagName }}
          </a-tag>
        </template>
        <template slot="option" slot-scope="record">
          <a-space>
            <a class="link_blue" type="primary" @click="doEdit(record.id)">编辑</a>
            <a-divider type="vertical"/>
            <a-popconfirm title="确认删除?" ok-text="是" cancel-text="否" @confirm="onDelete(record.id)">
              <a class="link_blue">删除</a>
            </a-popconfirm>
          </a-space>
        </template>
      </s-table>
    </a-card>
    <!-- modal -->
    <tag-add-modal ref="tagAddModal" @success="onAddSuccess"/>
    <tag-edit-modal ref="tagEditModal" @success="onEditSuccess"/>
    <tag-detail-modal ref="tagDetailModal" @success="onDetailSuccess"/>
  </page-view>
</template>

<script>
import { PageView } from '@/layouts'
import STable from '@comp/Table'
import TagAddModal from '@/epp/expertmain/experttag/modal/TagAddModal'
import TagEditModal from '@/epp/expertmain/experttag/modal/TagEditModal.vue'
import TagDetailModal from '@/epp/expertmain/experttag/modal/TagDetailModal'
import { DeleteTagInfo, QueryTagInfo } from '@/epp/expertmain/experttag/api/TagApi'

export default {
  name: 'TagIndex',
  components: {
    TagDetailModal,
    TagEditModal,
    TagAddModal,
    PageView,
    STable
  },
  data () {
    return {
      tag: {},
      modalVisible: {
        add: false
      },
      columns: [
        {
          title: '标签名称 (点击标签查看)',
          width: '20%',
          key: 'tagName',
          align: 'center',
          scopedSlots: { customRender: 'tagName' },
          ellipsis: true
        },
        { title: '标签描述', width: '15%', dataIndex: 'tagDetail', ellipsis: true },
        { title: '抽取优先级', width: '15%', align: 'center', dataIndex: 'extractPriorityFlagText' },
        { title: '创建人', width: '10%', dataIndex: 'createUserName' },
        { title: '创建时间', width: '15%', dataIndex: 'createTime' },
        { title: '更新时间', width: '15%', dataIndex: 'updateTime' },
        { title: '操作', width: '10%', key: 'option', align: 'center', scopedSlots: { customRender: 'option' } }
      ],
      loadData: parameter => {
        const params = { ...parameter, ...this.tag }
        return QueryTagInfo(params)
      }
    }
  },
  methods: {
    reset () {
      this.tag = {}
      this.$refs.table.refresh()
    },
    onSearch () {
      this.$refs.table.refresh()
    },
    tagAdd () {
      this.$refs.tagAddModal.onStartLoadData()
    },
    onAddSuccess () {
      this.$refs.table.refresh()
    },
    onEditSuccess () {
      this.$refs.table.refresh()
    },
    doEdit (id) {
      this.$refs.tagEditModal.onStartLoadData(id)
    },
    async onDelete (id) {
      try {
        let res = await DeleteTagInfo({ id: id })
        if (res.code !== 200) {
          this.$message.error('删除失败！')
          return
        }
        this.$message.success('删除成功！')
        this.onSearch()
      } catch (e) {
        this.$message.error(e.message)
      }
    },
    doDetail (id) {
      this.$refs.tagDetailModal.onStartLoadData(id)
    },
    onDetailSuccess () {
    }
  }
}
</script>

<style scoped>

</style>
